import React from "react";
import * as Yup from "yup";
import { TranslatedText } from "../../../helpers/helpers";

import { client } from "../../../App";
import {
  Authorization,
  CaseForms,
  CaseMutationType,
  CaseStepperType,
  Unita,
} from "../../../helpers/enums";
import {
  AGIORNA_DATI,
  getEvictionForMutation,
} from "../../../helpers/mutations";
import { CHECK_CONTRACT } from "../../../helpers/queries";
import { validEmail, validPhone } from "../../forms/CustomSignUp/validations";

const model = {
  formId: CaseForms.AggiornaDati,
  formField: {
    codiceCliente: {
      name: "codiceCliente",
      label: (
        <TranslatedText i18nKey="cases.lettura_sicura.disattiva.codiceCliente.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.lettura_sicura.disattiva.codiceCliente.placeholder" />
      ),
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.aggiorna.fields.codice_cliente.invalid" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="confirm.username.required" />,
      message: true,
      messageText: "info.message.codiceCliente",
      type: "input",
    },
    codiceContratto: {
      name: "codiceContratto",
      label: <TranslatedText i18nKey="common.clientCode" />,
      placeholder: <TranslatedText i18nKey="common.codiceClient" />,
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.aggiorna.fields.codice_contratto.invalid" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="confirm.username.required" />,
      message: true,
      messageText: "cases.aggiorna.codice_contratto.info.desc",
      type: "input",
    },
    numeroBolletta: {
      name: "numeroBolletta",
      label: <TranslatedText i18nKey="cases.aggiorna.dati.NumeroBolletta" />,
      placeholder: "Inserisci numero",
      requiredErrorMsg: <TranslatedText i18nKey="confirm.username.required" />,
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.aggiorna.fields.numero_bolleta.invalid" />
      ),
      message: true,
      messageText: "info.message.numeroBolletta",
      type: "input",
    },
    changeInput: {
      name: "changeInput",
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "button",
      title: <TranslatedText i18nKey="common.select" />,
      toggleOptionButton: true,
      firstOption: (
        <TranslatedText i18nKey="cases.aggiorna.fields.cta.show.contractCode" />
      ),
      secondOption: (
        <TranslatedText i18nKey="cases.aggiorna.fields.cta.show.clientCode" />
      ),
      onClick: (e, values, setFieldValue) => {
        setFieldValue(codiceCliente.name, "");
        setFieldValue(codiceContratto.name, "");
        if (e.target.classList.contains("firstOption")) {
          setFieldValue(changeInput.name, "secondOption");
        } else {
          setFieldValue(changeInput.name, "firstOption");
        }
        e.target.classList.toggle("firstOption");
        e.target.blur();
        e.target.closest("button").blur();
      },
    },
    error_message: {
      name: "error_message",
      type: "radio",
      options: [],
      summaryView: false,
    },
    contractId: {
      name: "contractId",
      label: (
        <TranslatedText i18nKey="cases.lettura_sicura.attiva.nome.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.lettura_sicura.attiva.nome.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "input",
    },
    clientId: {
      name: "clientId",
      label: (
        <TranslatedText i18nKey="cases.lettura_sicura.attiva.cognome.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.lettura_sicura.attiva.cognome.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "input",
    },
    name: {
      name: "name",
      label: (
        <TranslatedText i18nKey="cases.lettura_sicura.attiva.nome.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.lettura_sicura.attiva.nome.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "input",
    },
    surname: {
      name: "surname",
      label: (
        <TranslatedText i18nKey="cases.lettura_sicura.attiva.cognome.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.lettura_sicura.attiva.cognome.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "input",
    },
    particella: {
      name: "particella",
      label: (
        <TranslatedText i18nKey="cases.aggiorna.dati.fields.particella.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      message: true,
      messageText: "info.message.particella",
      type: "input",
    },
    subalterno: {
      name: "subalterno",
      label: (
        <TranslatedText i18nKey="cases.aggiorna.dati.fields.subalterno.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      message: true,
      messageText: "info.message.subalterno",
      type: "input",
    },
    unitaImmobiliare: {
      name: "unitaImmobiliare",
      label: (
        <TranslatedText i18nKey="cases.aggiorna.dati.step1_2.unita_immobiliare.label" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="errors.registration.public.fc.required" />
      ),
      type: "radio",
      options: [
        {
          label: <TranslatedText i18nKey="cases.aggiorna.abivita" />,
          value: Unita.ABITATIVA,
          grid: { xs: 12 },
        },
        {
          label: <TranslatedText i18nKey="cases.aggiorna.none_abivita" />,
          value: Unita.NONE_ABITATIVA,
          grid: { xs: 12 },
        },
      ],
    },
    aggiorna_numeroResidenti: {
      name: "aggiorna_numeroResidenti",
      label: (
        <TranslatedText i18nKey="cases.voltura.tipologia_uso.numero_residenti.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.voltura.fields.letturaFinale.invalid" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
      readonly: true,
      disabled: true,
    },
    numeroResidenti: {
      name: "numeroResidenti",
      label: (
        <TranslatedText i18nKey="cases.voltura.tipologia_uso.numero_residenti.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.voltura.fields.letturaFinale.invalid" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    presenti: {
      name: "presenti",
      label: (
        <TranslatedText i18nKey="cases.aggiorna.dati.step1_2.presenti.label" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="errors.registration.public.fc.required" />
      ),
      type: "radio",
      message: true,
      messageText: "info.message.presenti",
      options: [
        {
          label: <TranslatedText i18nKey="common.yes" />,
          value: "true",
          grid: { xs: 4 },
        },
        {
          label: <TranslatedText i18nKey="common.no" />,
          value: "false",
          grid: { xs: 4 },
        },
      ],
    },
    privacy: {
      name: "privacy",
      type: "checkbox",
      requiredErrorMsg: (
        <TranslatedText i18nKey="errors.registration.public.fc.required" />
      ),
      privacy: true,
    },
    autorizzazione: {
      name: "autorizzazione",
      requiredErrorMsg: (
        <TranslatedText i18nKey="errors.registration.public.fc.required" />
      ),
      type: "radio",
      options: [
        {
          label: <TranslatedText i18nKey="cases.aggiorna.dati.autorrizo" />,
          value: Authorization.AUTORIZZO,
          grid: { xs: 12 },
        },
        {
          label: <TranslatedText i18nKey="cases.aggiorna.dati.non_autorrizo" />,
          value: Authorization.NONE_AUTORIZZO,
          grid: { xs: 12 },
        },
      ],
    },
    aggiorna_postaElectronica: {
      name: "aggiorna_postaElectronica",
      label: (
        <TranslatedText i18nKey="cases.aggiorna.dati.postaElectronica.label" />
      ),
      placeholder: <TranslatedText i18nKey="email.modal.header" />,
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      readonly: true,
      disabled: true,
      type: "input",
      inputType: "mail",
    },
    aggiorna_mobilePhoneNumber: {
      name: "aggiorna_mobilePhoneNumber",
      label: <TranslatedText i18nKey="cases.aggiorna.cellulare.label" />,
      placeholder: (
        <TranslatedText i18nKey="cases.lettura_sicura.attiva.cellulare.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      invalidErrorMsg: <TranslatedText i18nKey="cases.errors.phone_invalid" />,
      readonly: true,
      disabled: true,
      type: "input",
    },
    aggiorna_postaCartacea: {
      name: "aggiorna_postaCartacea",
      label: (
        <TranslatedText i18nKey="cases.aggiorna.dati.postaCartacea.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.aggiorna.dati.postaCartacea.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      readonly: true,
      disabled: true,
      type: "input",
    },
    postaElectronica: {
      name: "postaElectronica",
      label: (
        <TranslatedText i18nKey="cases.aggiorna.dati.postaElectronica.label" />
      ),
      placeholder: <TranslatedText i18nKey="email.modal.header" />,
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "input",
      invalidErrorMsg: <TranslatedText i18nKey="cases.aggiorna.errors.email" />,
    },
    mobilePhoneNumber: {
      name: "mobilePhoneNumber",
      label: (
        <TranslatedText i18nKey="cases.lettura_sicura.attiva.cellulare.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.lettura_sicura.attiva.cellulare.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      invalidErrorMsg: <TranslatedText i18nKey="cases.errors.phone_invalid" />,
      type: "input",
    },
    postaCartacea: {
      name: "postaCartacea",
      label: (
        <TranslatedText i18nKey="cases.aggiorna.dati.postaCartacea.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.aggiorna.dati.postaCartacea.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "google-address",
      suggestionType: "address",
      onSelect: (components, setFieldValue) => {
        setFieldValue(
          postaCartacea.name,
          `${components.via}, ${components.civico || ""} ${
            components.cap || ""
          }, ${components.comune || ""}, ${components.provincia || ""}`
        );
      },
    },
  },
};
const {
  formField: {
    codiceCliente,
    codiceContratto,
    numeroBolletta,
    changeInput,
    name,
    surname,
    error_message,
    particella,
    subalterno,
    unitaImmobiliare,
    aggiorna_numeroResidenti,
    numeroResidenti,
    presenti,
    privacy,
    autorizzazione,
    aggiorna_postaElectronica,
    aggiorna_mobilePhoneNumber,
    aggiorna_postaCartacea,
    postaElectronica,
    mobilePhoneNumber,
    postaCartacea,
    contractId,
    clientId,
  },
} = model;

// initialValues contiene i valori iniziali del form, ne imposta anche i campi.
// Si può usare per popolare il form eventualmente.
const initialValues = {
  [codiceCliente.name]: "",
  [codiceContratto.name]: "",
  [numeroBolletta.name]: "",
  [changeInput.name]: "firstOption",
  [name.name]: "",
  [surname.name]: "",
  [error_message.name]: "",
  [particella.name]: "",
  [subalterno.name]: "",
  [unitaImmobiliare.name]: "",
  [aggiorna_numeroResidenti.name]: "",
  [numeroResidenti.name]: "",
  [presenti.name]: "",
  [privacy.name]: false,
  [autorizzazione.name]: "",
  [aggiorna_postaElectronica.name]: "",
  [aggiorna_mobilePhoneNumber.name]: "",
  [aggiorna_postaCartacea.name]: "",
  [postaElectronica.name]: "",
  [mobilePhoneNumber.name]: "",
  [postaCartacea.name]: "",
  [contractId.name]: "",
  [clientId.name]: "",
};

// Per definire il validationSchema si usa un array di shape che indicano gli step.
// L'ordine degli step deve corrispondere a quello in layout.

const getValidationSchema = () => {
  return [
    Yup.object().shape({
      [codiceCliente.name]: Yup.string().when(changeInput.name, {
        is: (option) => option === "firstOption",
        then: Yup.string().required(codiceCliente.requiredErrorMsg),
        otherwise: Yup.string().notRequired(),
      }),
      [codiceContratto.name]: Yup.string().when(changeInput.name, {
        is: (option) => option === "secondOption",
        then: Yup.string().required(codiceContratto.requiredErrorMsg),
        otherwise: Yup.string().notRequired(),
      }),
      [numeroBolletta.name]: Yup.string().required(
        numeroBolletta.requiredErrorMsg
      ),
    }),
    Yup.object()
      .shape({
        [name.name]: Yup.string().required(name.requiredErrorMsg),
        [surname.name]: Yup.string().required(surname.requiredErrorMsg),
        [particella.name]: Yup.number()
          .typeError(
            <TranslatedText i18nKey="cases.aggiorna.particella.nr.error" />
          )
          .required(particella.requiredErrorMsg),
        [subalterno.name]: Yup.number()
          .typeError(
            <TranslatedText i18nKey="cases.aggiorna.subalterno.nr.error" />
          )
          .required(subalterno.requiredErrorMsg),
        [unitaImmobiliare.name]: Yup.string().required(
          unitaImmobiliare.requiredErrorMsg
        ),
        [numeroResidenti.name]: Yup.number()
          .typeError(<TranslatedText i18nKey="errors.numero_residenti.text" />)
          .min(1, <TranslatedText i18nKey="errors.numero_residenti.text" />)
          .max(10, <TranslatedText i18nKey="errors.numero_residenti.long" />)
          .when(unitaImmobiliare.name, {
            is: (unitaImmobiliare) => unitaImmobiliare === Unita.ABITATIVA,
            then: Yup.number().required(numeroResidenti.requiredErrorMsg),
          }),
        [presenti.name]: Yup.string().required(presenti.requiredErrorMsg),
        [privacy.name]: Yup.boolean()
          .required(privacy.requiredErrorMsg)
          .oneOf([true], privacy.requiredErrorMsg),
        [autorizzazione.name]: Yup.string().required(
          autorizzazione.requiredErrorMsg
        ),
        [mobilePhoneNumber.name]: Yup.string().matches(validPhone, {
          message: mobilePhoneNumber.invalidErrorMsg,
        }),
        [postaElectronica.name]: Yup.string().matches(validEmail, {
          message: postaElectronica.invalidErrorMsg,
        }),
      })
      .test("myCustomTest", null, (value) => {
        if (
          value.postaCartacea ||
          value.mobilePhoneNumber ||
          value.postaElectronica
        ) {
          return true; // everything is fine
        } else if (value.autorizzazione === Authorization.NONE_AUTORIZZO) {
          return true;
        }
        return new Yup.ValidationError(
          (
            <TranslatedText i18nKey="cases.aggiorna.dati.selection.error_message" />
          ),
          null,
          error_message.name
        );
      }),
  ];
};

// Il layout contiene informazioni di testo e di distribuzione sulle griglie

const getLayout = () => {
  return [
    {
      chapter: true,
      chapterName: <TranslatedText i18nKey="cases.aggiorna.dati.title.1" />,
      title: "",
      beforeSubmit: async (values, { setFieldValue, setErrors }) => {
        let queryVariables;
        if (values.changeInput === "firstOption") {
          queryVariables = {
            integraClientCode: values.codiceCliente,
            invoiceNumber: values.numeroBolletta,
          };
        } else {
          queryVariables = {
            integraContractCode: values.codiceContratto,
            invoiceNumber: values.numeroBolletta,
          };
        }
        await new Promise((resolve, reject) => {
          client()
            .query({
              query: CHECK_CONTRACT,
              variables: queryVariables,
            })
            .then(({ data }) => {
              console.log(data, "data");
              const { contractId, clientId } = data.checkContract;

              // if (status.code === "FC00") {
              //   setErrors({ codiceCliente: codiceCliente.inactiveErrorMsg });
              //   reject();
              // } else {
              // step 1.2
              setFieldValue("contractId", contractId);
              setFieldValue("clientId", clientId);
              resolve();
              // }
            })
            .catch((error) => {
              if (values.changeInput === "firstOption") {
                setErrors({
                  codiceCliente: codiceCliente.invalidErrorMsg,
                  numeroBolletta: numeroBolletta.invalidErrorMsg,
                });
              } else {
                setErrors({
                  codiceContratto: codiceContratto.invalidErrorMsg,
                  numeroBolletta: numeroBolletta.invalidErrorMsg,
                });
              }
              reject(error);
            });
        });
      },

      fields: [
        {
          fieldName: null,
          text: (
            <h2 className="case-step-title-aggiorna">
              <TranslatedText i18nKey="cases.aggiorna.dati.titles.title1" />
            </h2>
          ),
          grid: {
            xs: 12,
          },
        },
        {
          fieldName: codiceCliente.name,
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "changeInput",
              is: "firstOption",
            },
          ],
        },
        {
          fieldName: "codiceContratto",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "changeInput",
              is: "secondOption",
            },
          ],
        },
        {
          fieldName: numeroBolletta.name,
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          fieldName: changeInput.name,
          grid: {
            xs: 12,
            md: 12,
          },
        },
      ],
    },
    {
      chapter: true,
      chapterName: <TranslatedText i18nKey="cases.aggiorna.dati.title.2" />,
      title: "",
      fields: [
        {
          fieldName: null,

          text: (
            <h2 className="case-step-title-aggiorna">
              <TranslatedText i18nKey="cases.aggiorna.case-step-title1" />
            </h2>
          ),
          grid: {
            xs: 12,
          },
        },
        {
          fieldName: name.name,
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          fieldName: surname.name,
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          fieldName: null,

          text: (
            <h2 className="case-step-title-aggiorna">
              <TranslatedText i18nKey="cases.aggiorna.case-step-title2" />
            </h2>
          ),
          grid: {
            xs: 12,
          },
        },
        {
          fieldName: particella.name,
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          fieldName: subalterno.name,
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          fieldName: unitaImmobiliare.name,
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          fieldName: aggiorna_numeroResidenti.name,
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "unitaImmobiliare",
              is: Unita.NONE_ABITATIVA,
              or: "",
            },
          ],
        },
        {
          fieldName: numeroResidenti.name,
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "unitaImmobiliare",
              is: Unita.ABITATIVA,
            },
          ],
        },
        {
          fieldName: presenti.name,
          grid: {
            xs: 12,
            md: 6,
          },
          className: "text-margin",
        },
        {
          fieldName: null,
          text: (
            <h2 className="case-step-title-aggiorna">
              <TranslatedText i18nKey="cases.aggiorna.case-step-title3" />
            </h2>
          ),
          grid: {
            xs: 12,
          },
        },
        {
          fieldName: privacy.name,
          grid: {
            xs: 12,
            md: 12,
          },
        },
        {
          fieldName: null,
          text: (
            <p className="text-1">
              <TranslatedText i18nKey="cases.aggiorna.dati.layout.privacy.sub_text" />
            </p>
          ),
          grid: {
            xs: 12,
          },
        },
        {
          fieldName: autorizzazione.name,
          grid: {
            xs: 12,
            md: 12,
          },
        },
        {
          fieldName: null,
          text: (
            <div className="text-1">
              <p>
                <TranslatedText i18nKey="cases.aggiorna.dati.layout.privacy.sub_text1" />
                <b>
                  <TranslatedText i18nKey="cases.aggiorna.dati.layout.privacy.sub_text2" />
                </b>
                <TranslatedText i18nKey="cases.aggiorna.dati.layout.privacy.sub_text3" />
              </p>
              <p>
                <TranslatedText i18nKey="cases.aggiorna.dati.layout.privacy.sub_text4" />
                <b>
                  <TranslatedText i18nKey="cases.aggiorna.dati.layout.privacy.sub_text5" />{" "}
                </b>
                <TranslatedText i18nKey="cases.aggiorna.dati.layout.privacy.sub_text6" />
                <a className="link-a" href={`mailto:privacy@gruppocap.it`}>
                  privacy@gruppocap.it
                </a>
                <TranslatedText i18nKey="cases.aggiorna.dati.layout.privacy.sub_text8" />
              </p>
            </div>
          ),
          grid: {
            xs: 10,
          },
        },
        {
          fieldName: null,
          text: (
            <p className="text-1">
              <TranslatedText i18nKey="cases.aggiorna.case-step-title4" />
            </p>
          ),
          grid: {
            xs: 12,
          },
        },
        {
          fieldName: aggiorna_postaElectronica.name,
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "autorizzazione",
              is: "",
              or: Authorization.NONE_AUTORIZZO,
            },
          ],
        },
        {
          fieldName: aggiorna_mobilePhoneNumber.name,
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "autorizzazione",
              is: "",
              or: Authorization.NONE_AUTORIZZO,
            },
          ],
        },
        {
          fieldName: aggiorna_postaCartacea.name,
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "autorizzazione",
              is: "",
              or: Authorization.NONE_AUTORIZZO,
            },
          ],
        },
        {
          fieldName: postaElectronica.name,
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "autorizzazione",
              is: Authorization.AUTORIZZO,
            },
          ],
        },
        {
          fieldName: mobilePhoneNumber.name,
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "autorizzazione",
              is: Authorization.AUTORIZZO,
            },
          ],
        },
        {
          fieldName: postaCartacea.name,
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "autorizzazione",
              is: Authorization.AUTORIZZO,
            },
          ],
        },
        {
          fieldName: error_message.name,
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "autorizzazione",
              is: Authorization.AUTORIZZO,
            },
          ],
          className: "errorMessage",
        },
      ],
    },
  ];
};

// Contiene dettagli sul case form
const formDetails = {
  title: null,
  description: null,
  summary: false,
  stepper: CaseStepperType.Full,
  helpText: null,
  submitButton: "cases.aggriona.submit",
  successText: (
    <div>
      <p>
        <TranslatedText i18nKey="cases.request_info.success_text" />
      </p>
    </div>
  ),
};
const translatedMapping = (payload) => {
  return {
    contractId: payload[contractId.name],
    clientId: payload[clientId.name],
    parcel: payload[particella.name],
    subaltern: payload[subalterno.name],
    housingUnit: payload[unitaImmobiliare.name],
    residentNumber:
      payload[unitaImmobiliare.name] !== Unita.NONE_ABITATIVA
        ? payload[numeroResidenti.name]
        : "",
    name: payload[name.name],
    surname: payload[surname.name],
    email: payload[postaElectronica.name],
    phone: payload[mobilePhoneNumber.name],
    address: payload[postaCartacea.name],
    privacy: payload[privacy.name],
    divisionalMeters: payload[presenti.name] === "true",
    contactAuthorization:
      payload[autorizzazione.name] === Authorization.AUTORIZZO,
  };
};

const translatedInverseMapping = (payload, values) => {
  const errorsFields = payload.map(({ field, message }) => {
    return { field, message };
  });
  const mapping = {
    "req.contractId": contractId.name,
    "req.clientId": clientId.name,
    "req.parcel": particella.name,
    "req.subaltern": subalterno.name,
    "req.housingUnit": unitaImmobiliare.name,
    "req.residentNumber": numeroResidenti.name,
    "req.name": name.name,
    "req.surname": surname.name,
    "req.email": postaElectronica.name,
    "req.phone": mobilePhoneNumber.name,
    "req.address": postaCartacea.name,
    "req.privacy": privacy.name,
    "req.divisionalMeters": presenti.name,
  };

  return errorsFields.reduce((acc, item) => {
    acc[mapping[item.field]] = item.message;
    return acc;
  }, {});
};

const mutation = {
  type: CaseMutationType.Custom,
  mutation: AGIORNA_DATI,
  refetchQueries: getEvictionForMutation("createCondominiumRegistry"),
};

const main = () => {
  return {
    model,
    validationSchema: getValidationSchema(),
    initialValues,
    layout: getLayout(),
    formDetails,
    mutation,
    translatedMapping,
    translatedInverseMapping,
  };
};

export default main;
